import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import SideBarCustom from "../../components/Sidebar";
import HeaderCustom from "../../components/Header";
import Login from "../login";
import AccountList from "../account/list";
import CreateAccount from "../account/create";
import { Layout } from "antd";
import HistoryList from "../history/conversionHis";
import PlayHistoryList from "../history/playHis";
import GamingHistoryList from "../history/gamingHis";
import OnOffGame from "../manager-game/onOffGame";
import SetupCondition from "../manager-game/setupCondition";
import SetupScore from "../manager-game/setupScore";
import SetupRule from "../manager-game/setupRule";
import UpdateTurn from "../manager-game/updateTurn";
import PopupFakeUserManager from "../manager-game/popupFakeUser";
import ConfirmResult from "../manager-game/confirmResult";
import Leaderboard from "../manager-game/leaderboard";
import LeaderboardSettings from "../manager-game/leaderboardSettings";
import Dashboard from "../dashboard";

const { Sider, Content } = Layout;

const Main = () => {
  const auth = localStorage.getItem("auth");
  const [collapsed, setCollapsed] = useState(false);

  const renderPublic = () => {
    return (
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    );
  };

  const renderContent = () => {
    return (
      <Layout>
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          className="site-body"
        >
          <SideBarCustom />
        </Sider>
        <Layout className="site-layout">
          <HeaderCustom
            collapsed={collapsed}
            updateCollapsed={() => setCollapsed(!collapsed)}
            username={JSON.parse(auth).username}
          />
          <Content
            className="site-layout-background"
            style={{
              margin: "24px 16px",
              padding: 24,
            }}
          >
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/account" element={<AccountList />} />
              <Route path="/createAccount" element={<CreateAccount />} />
              <Route path="/conversionHis" element={<HistoryList />} />
              <Route path="/playHis" element={<PlayHistoryList />} />
              <Route path="/gamingHis" element={<GamingHistoryList />} />
              <Route path="/setup_countdown" element={<OnOffGame />} />
              <Route path="/setup_condition" element={<SetupCondition />} />
              <Route path="/setup_score" element={<SetupScore />} />
              <Route path="/setup_rule" element={<SetupRule />} />
              <Route path="/update_turn" element={<UpdateTurn />} />
              <Route path="/popup_fake_user" element={<PopupFakeUserManager />} />
              <Route path="/confirm_result" element={<ConfirmResult />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/leaderboard_settings" element={<LeaderboardSettings />} />
            </Routes>
          </Content>
        </Layout>
      </Layout>
    );
  };

  return <>{auth ? renderContent() : renderPublic()}</>;
};

export default Main;
